import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  minutesAgo: number;
}
const purchasePool: Purchase[] = [{
  name: 'Martín G.',
  city: 'Buenos Aires',
  minutesAgo: 3
}, {
  name: 'Sofía P.',
  city: 'Córdoba',
  minutesAgo: 7
}, {
  name: 'Juan C.',
  city: 'Rosario',
  minutesAgo: 12
}, {
  name: 'Valentina R.',
  city: 'Mendoza',
  minutesAgo: 5
}, {
  name: 'Tomás L.',
  city: 'La Plata',
  minutesAgo: 9
}, {
  name: 'Camila F.',
  city: 'Mar del Plata',
  minutesAgo: 15
}, {
  name: 'Agustín B.',
  city: 'Salta',
  minutesAgo: 4
}, {
  name: 'Lucía M.',
  city: 'Tucumán',
  minutesAgo: 11
}, {
  name: 'Mateo S.',
  city: 'Neuquén',
  minutesAgo: 6
}, {
  name: 'Florencia D.',
  city: 'Santa Fe',
  minutesAgo: 8
}, {
  name: 'Nicolás A.',
  city: 'San Juan',
  minutesAgo: 13
}, {
  name: 'Julieta V.',
  city: 'Bahía Blanca',
  minutesAgo: 10
}, {
  name: 'Santiago M.',
  city: 'Paraná',
  minutesAgo: 14
}, {
  name: 'Catalina L.',
  city: 'Corrientes',
  minutesAgo: 7
}, {
  name: 'Federico R.',
  city: 'Posadas',
  minutesAgo: 5
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  useEffect(() => {
    // First popup after 15-20 seconds
    const initialDelay = 15000 + Math.random() * 5000;
    const showPopup = () => {
      const randomPurchase = purchasePool[Math.floor(Math.random() * purchasePool.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      // Hide after 5-6 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000 + Math.random() * 1000);
    };
    const initialTimer = setTimeout(showPopup, initialDelay);
    // Subsequent popups every 40-60 seconds
    const recurringInterval = setInterval(() => {
      showPopup();
    }, 40000 + Math.random() * 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(recurringInterval);
    };
  }, []);
  const handleClose = () => {
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-233">
      {isVisible && currentPurchase && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-4 left-4 z-50 w-[280px] sm:w-[320px]" data-id="element-234">
          <div className="bg-white border-l-4 border-lime-500 rounded-lg shadow-2xl p-4 relative" data-id="element-235">
            <button onClick={handleClose} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar" data-id="element-236">
              <X className="w-4 h-4" data-id="element-237" />
            </button>

            <div className="flex items-start gap-3" data-id="element-238">
              <div className="bg-lime-100 p-2 rounded-full flex-shrink-0" data-id="element-239">
                <CheckCircle className="w-5 h-5 text-lime-600" data-id="element-240" />
              </div>

              <div className="flex-1 pr-4" data-id="element-241">
                <div className="flex items-center gap-2 mb-1" data-id="element-242">
                  <span className="text-xs font-bold text-lime-700 uppercase tracking-wide" data-id="element-243">
                    Compra verificada ✓
                  </span>
                </div>

                <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-244">
                  {currentPurchase.name} · {currentPurchase.city}
                </p>

                <p className="text-xs text-gray-600 mb-1" data-id="element-245">Huerta Express 30D</p>

                <p className="text-xs text-gray-500" data-id="element-246">
                  hace {currentPurchase.minutesAgo} minutos
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}